var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilitiesHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1934,
    height: 491,
    viewBox: "0 0 1934 491",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "77.906%",
    x2: "52.627%",
    y2: "77.906%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.49,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECF6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "110.684%",
    y2: "50%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F0F7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DBE6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "100%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.457%",
    y1: "-18.033%",
    x2: "43.252%",
    y2: "78.132%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEF5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.121%",
    y1: "-18.033%",
    x2: "43.52%",
    y2: "78.132%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEF5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.783%",
    y1: "-18.033%",
    x2: "42.992%",
    y2: "78.132%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEF5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "57.663%",
    y1: "-18.033%",
    x2: "43.885%",
    y2: "78.132%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEF5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.164%",
    y1: "-18.033%",
    x2: "14.758%",
    y2: "78.132%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEF5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.079%",
    y1: "-18.033%",
    x2: "18.816%",
    y2: "78.132%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEF5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.836%",
    y1: "86.365%",
    x2: "7.51%",
    y2: "86.365%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.353,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 41h126.94s6.885-8.738 0-14.619c-3.798-3.245-8.285-2.909-11.543-1.956-2.124.622-4.24-.816-4.706-2.985-.773-3.593-3.152-8.294-9.985-11.073-6.723-2.732-10.974 1.441-13.434 5.729-.81 1.41-2.965 1.198-3.454-.353C81.688 8.973 74.261 0 49.86 0 18.826 0 22.275 16.555 25.048 23.436c.481 1.195-.538 2.433-1.794 2.164-4.788-1.027-13.673-2.358-17.658.781C0 30.79 0 41 0 41",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 41h126.94s6.885-8.738 0-14.619c-3.798-3.245-8.285-2.909-11.543-1.956-2.124.622-4.24-.816-4.706-2.985-.773-3.593-3.152-8.294-9.985-11.073-6.723-2.732-10.974 1.441-13.434 5.729-.81 1.41-2.965 1.198-3.454-.353C81.688 8.973 74.261 0 49.86 0 18.826 0 22.275 16.555 25.048 23.436c.481 1.195-.538 2.433-1.794 2.164-4.788-1.027-13.673-2.358-17.658.781C0 30.79 0 41 0 41",
    id: "e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFB",
    d: "M0 0h1901v491H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.143 81.218l-13.895 11.46 13.844 4.55-13.298 12.681a.1.1 0 00.122.157l23.875-15.016-10.92-4.412 9.266-5.786-8.994-3.634z",
    fill: "#AAB2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 147.5v-4c19.952-2.648 36.686-4.566 50.202-5.752 35.952-3.188 44.366-18.98 63.342-16.904 8.488.926 7.598 4.93 15.122 5.523 15.678 1.224 22.461-14.457 46.405-17.2 21.682-2.484 50.332 6.487 64.12 15.495 10.267 6.71 9.933 11.863 21.905 14.754 12.046 2.929 21.534-2.113 36.693-.667 14.048 1.372 31.023 12.419 37.991 18.202L0 157v-9.5z",
    fill: "url(#a)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.131 204.289a16.926 16.926 0 01-5.319-.85 1.52 1.52 0 00-1.52.358l-3.277 3.277a22.417 22.417 0 01-9.82-9.82l3.278-3.29a1.43 1.43 0 00.372-1.49 16.926 16.926 0 01-.85-5.32 1.495 1.495 0 00-1.489-1.49h-5.215a1.495 1.495 0 00-1.49 1.49 25.326 25.326 0 0025.33 25.329 1.495 1.495 0 001.49-1.49v-5.215a1.495 1.495 0 00-1.49-1.49zm249.014-155.164c-11.253-11.022-28.57-11.022-39.823 0a1.102 1.102 0 00-.322.768c-.004.292.104.573.3.779l2.165 2.285a.983.983 0 001.416.026c9.263-8.994 23.443-8.994 32.706 0a.983.983 0 001.416-.026l2.165-2.285c.196-.206.304-.487.3-.779a1.102 1.102 0 00-.322-.768h-.001zm-19.912 13.261c-2.234 0-4.046 1.928-4.046 4.306s1.812 4.305 4.046 4.305c2.235 0 4.047-1.927 4.047-4.305 0-2.378-1.812-4.306-4.047-4.306zm12.815-5.623c-7.329-6.853-18.3-6.853-25.629 0-.208.196-.33.475-.337.77-.007.296.102.58.301.787l2.178 2.287c.381.4.986.423 1.394.053 5.337-4.876 13.22-4.876 18.557 0a.986.986 0 001.394-.053l2.178-2.287a1.09 1.09 0 00.3-.787 1.092 1.092 0 00-.336-.77z",
    fill: "#AAB2CD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeDasharray: 4,
    d: "M1423 210.5l-112.5-1m220-127v117m-79-84v91m-28.5 73h-112.5m108.5 69h-108.5"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#AAB2CD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1303 263.474a2 2 0 012 2V288a2 2 0 01-2 2h-28a2 2 0 01-2-2v-22.526a2 2 0 012-2h28zm-3 3.06h-22a2 2 0 00-2 2h0v16.405a2 2 0 002 2h22a2 2 0 002-2h0v-16.405a2 2 0 00-2-2h0z",
    fill: "#AAB2CD"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1279.003 254.608l7.173 8.866m5.648 1.894l7.529-11.368"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1766.3 417.568h-2.034c-13.707 0-24.919-13.54-24.919-30.09v-22.646c0-16.552 11.212-30.095 24.919-30.095h2.035c13.706 0 24.918 13.543 24.918 30.095v22.645c0 16.552-11.212 30.091-24.918 30.091",
    fillOpacity: 0.379,
    fill: "#867FD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.283 391.688c-1.276 0-2.312 1.25-2.312 2.792v44.755l-5.45-6.582c-.904-1.09-2.368-1.09-3.271 0-.904 1.09-.904 2.855 0 3.946l8.715 10.52.006 15.826c0 1.541 1.036 2.792 2.312 2.792 1.277 0 2.312-1.25 2.312-2.792V394.48c0-1.541-1.035-2.792-2.312-2.792",
    fillOpacity: 0.8,
    fill: "#4F3E84"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206 61)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0EB",
    d: "M1418 454h145V199h-145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8B6DE",
    d: "M1406 332h167v-5h-167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8496C8",
    d: "M1413 227h154v-5h-154zm-7 105c9.67 0 5.92 6 11.454 6h144.092c5.533 0 1.783-6 11.454-6h-167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8D6",
    d: "M1418 199h145v-13h-145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFD4",
    d: "M1432 308h33v-72h-33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0F1",
    d: "M1435 302.93h27v-63.888h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M14.654 66.93H11l19-51.72v9.946L14.654 66.93",
    transform: "translate(1432 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M3.442 66.93H3V44.019L17.469 3.042H26L3.442 66.93",
    transform: "translate(1432 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFD4",
    d: "M1435 274.535h27v-2.028h-27zM1443 402h22v-49h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAF5",
    d: "M1445 398.936h18v-42.893h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M9.5 45.936H7l13-34.723v6.678L9.5 45.936",
    transform: "translate(1443 353)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M2.288 45.936H2V30.554l9.436-27.511H17L2.288 45.936",
    transform: "translate(1443 353)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFD4",
    d: "M1445 380.553h18v-2.042h-18zM1512 402h22v-49h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EAF5",
    d: "M1514 398.936h18v-42.893h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M9.5 45.936H7l13-34.723v6.678L9.5 45.936",
    transform: "translate(1512 353)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M2.288 45.936H2V30.554l9.436-27.511H17L2.288 45.936",
    transform: "translate(1512 353)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFD4",
    d: "M1514 380.553h18v-2.042h-18zM1474 308h33v-72h-33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0F1",
    d: "M1477 302.93h27v-63.888h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M14.654 66.93H11l19-51.72v9.946L14.654 66.93",
    transform: "translate(1474 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M3 66.93V44.019L17.469 3.042H26L3.442 66.93z",
    transform: "translate(1474 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFD4",
    d: "M1477 274.535h27v-2.028h-27zM1516 308h33v-72h-33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0F1",
    d: "M1519 302.93h27v-63.888h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M14.654 66.93H11l19-51.72v9.946L14.654 66.93",
    transform: "translate(1516 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M3.442 66.93H3V44.019L17.469 3.042H26L3.442 66.93",
    transform: "translate(1516 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7AFD4",
    d: "M1519 274.535h27v-2.028h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 454h33v-75.5c0-9.113-7.387-16.5-16.5-16.5s-16.5 7.387-16.5 16.5V454z",
    fillOpacity: 0.601,
    fill: "#8484C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502.248 416h-2.496c-.415 0-.752-.265-.752-.592v-6.815c0-.328.337-.593.752-.593h2.496c.416 0 .752.265.752.593v6.815c0 .327-.336.592-.752.592",
    fill: "#D1D9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502 412a1 1 0 11-2 0 1 1 0 012 0",
    fill: "#A7AFD4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18898D",
    d: "M1657.514 378.395l-.027.21.026-.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.85 440.857c-52.792-9.306-98.996-24.374-152.279-33.18-110.337-18.235-232.23-3.647-353.931 10.941-123.95 14.858-247.702 29.716-358.841 9.898-151.731-27.056-206.565-79.186-410.005-2.103C95.644 440.11 51.712 453.973 0 468v23l1933.925-.081c-30.327-9.75-64.277-17.521-100.494-22.729-136.668-19.65-293.424-3.865-426.58-27.333z",
    fill: "#E7EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186 415h-143.126a2.876 2.876 0 01-2.874-2.874V402h146v13",
    fill: "#818DB4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACB1BF",
    d: "M1046 428h140v-13h-140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.498 435c-1.38 0-2.498-1.317-2.498-2.941V415h5v17.059c0 1.624-1.118 2.941-2.502 2.941",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.602 337.868a7.021 7.021 0 00-5.663-2.868h-23.925a7.014 7.014 0 00-7.014 7.012v78.976a7.014 7.014 0 007.014 7.012h54.966c3.879 0 7.02-3.14 7.02-7.012V384.34c0-1.49-.477-2.941-1.356-4.143l-31.042-42.33z",
    fill: "#D6D8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.87 385.983l-8.289-1.002c-1.012-.122-1.711-.884-1.56-1.703.155-.82 1.098-1.383 2.11-1.261l8.288 1.001c1.012.123 1.711.885 1.56 1.704-.15.819-1.092 1.383-2.11 1.261",
    fill: "#405E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 428h58l-.13-27.098a6.447 6.447 0 00-5.469-6.375l-39.926-6.106a6.446 6.446 0 01-5.469-6.375V335a7.008 7.008 0 00-7.006 7.012V428z",
    fill: "#A6B1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.74 428H1233v-13h14.74c3.46 0 6.26 2.91 6.26 6.5s-2.8 6.5-6.26 6.5",
    fill: "#ACB1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 435c0-15.44-12.334-28-27.497-28S1055 419.56 1055 435h55",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057 435c0-13.785 11.44-25 25.503-25 14.062 0 25.497 11.215 25.497 25h-51",
    fill: "#818DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232 435c0-15.44-12.34-28-27.503-28S1177 419.56 1177 435h55",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179 435c0-13.785 11.435-25 25.497-25S1230 421.215 1230 435h-51",
    fill: "#818DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101 435c0 10.493-8.502 19-18.997 19S1063 445.493 1063 435s8.508-19 19.003-19c10.495 0 18.997 8.507 18.997 19m123 0c0 10.493-8.508 19-19.003 19-10.495 0-18.997-8.507-18.997-19s8.502-19 18.997-19S1224 424.507 1224 435",
    fill: "#707996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082 445c-5.526 0-10-4.477-10-10s4.474-10 10-10c5.52 0 10 4.477 10 10s-4.48 10-10 10zm133-10c0 5.523-4.48 10-10 10s-10-4.477-10-10 4.48-10 10-10 10 4.477 10 10",
    fill: "#B1BAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.516 384c-.218 0-.436-.015-.653-.047l-36.99-5.221c-2.208-.313-3.873-2.247-3.873-4.5v-30.689c0-2.505 2.018-4.543 4.5-4.543h10.934c1.426 0 2.786.694 3.63 1.858l26.053 35.911c1.023 1.41 1.164 3.179.386 4.733-.772 1.541-2.3 2.498-3.987 2.498",
    fill: "#EDEEF5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M170 78.042l.5-15.542 22.5-19 6 8-28.404 26.542z",
    transform: "translate(1020 303)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M190.31 72.444L203 57.5l3.5 5-15 15.5z",
    transform: "translate(1020 303)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#405E7A",
    d: "M1244 407h3v-15h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.68 393H1247v13h1.68c1.832 0 3.32-2.91 3.32-6.5s-1.488-6.5-3.32-6.5",
    fill: "#9AA9D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.977 402h-135.96a7.016 7.016 0 01-7.017-7.015v-84.971a7.016 7.016 0 017.017-7.014h135.96c3.88 0 7.023 3.14 7.023 7.014v84.971a7.017 7.017 0 01-7.023 7.015",
    fill: "#CAD1EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.717 365.647h-114.44c-1.257 0-2.277.975-2.277 2.177s1.02 2.176 2.278 2.176h114.439c1.258 0 2.283-.974 2.283-2.176 0-1.202-1.025-2.177-2.283-2.177zm0-16.323h-114.44c-1.257 0-2.277.974-2.277 2.176 0 1.202 1.02 2.176 2.278 2.176h114.439c1.258 0 2.283-.974 2.283-2.176 0-1.202-1.025-2.176-2.283-2.176zm-114.44-11.971h114.44c1.258 0 2.283-.974 2.283-2.177 0-1.201-1.025-2.176-2.283-2.176h-114.44c-1.257 0-2.277.975-2.277 2.176 0 1.203 1.02 2.177 2.278 2.177z",
    fill: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 354c0 17.122 13.881 31 31 31 17.122 0 31-13.878 31-31 0-17.119-13.878-31-31-31-17.119 0-31 13.881-31 31",
    fill: "#D2DAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.857 368c-1.184 0-2.144 1.03-2.144 2.3v36.868l-5.053-5.422c-.84-.898-2.195-.898-3.032 0-.837.899-.837 2.352 0 3.25l8.08 8.667.005 13.037c0 1.27.96 2.3 2.144 2.3 1.183 0 2.143-1.03 2.143-2.3v-56.4c0-1.27-.96-2.3-2.143-2.3",
    fillOpacity: 0.8,
    fill: "#4F3E84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 398.502c0 6.903 5.598 12.498 12.502 12.498 6.903 0 12.498-5.595 12.498-12.498 0-6.904-5.595-12.502-12.498-12.502-6.904 0-12.502 5.598-12.502 12.502",
    fill: "#D2DAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.49 434c-.823 0-1.49.653-1.49 1.459v31.081c0 .806.667 1.46 1.49 1.46H1598v-34h-35.51",
    fill: "#BDBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.58 434H1598v34h9.58c.783 0 1.42-.654 1.42-1.46v-31.08c0-.806-.637-1.459-1.42-1.459M1561 454h37v-6h-37z",
    fill: "#818DB4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#818DB4",
    d: "M1575 468h6v-34h-6zm-9-2h8v-2.066h-8V466zm0-2.967h8v-2.066h-8v2.066zm0-2.966h8V458h-8v2.067z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.49 434c-.823 0-1.49.653-1.49 1.459v31.081c0 .806.667 1.46 1.49 1.46H1643v-34h-35.51",
    fill: "#BDBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643 434v34h9.58c.784 0 1.42-.654 1.42-1.46v-31.08c0-.806-.636-1.459-1.42-1.459H1643zm-37 20h37v-6h-37z",
    fill: "#818DB4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#818DB4",
    d: "M1620 468h6v-34h-6zm-9-2h8v-2.066h-8V466zm0-2.967h8v-2.066h-8v2.066zm0-2.966h8V458h-8v2.067z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575 401.46v31.08c0 .807.667 1.46 1.49 1.46H1612v-34h-35.51c-.823 0-1.49.653-1.49 1.46zm-234 24v31.08c0 .807.667 1.46 1.49 1.46H1378v-34h-35.51c-.823 0-1.49.653-1.49 1.46z",
    fill: "#BDBFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.58 400H1612v34h9.58c.784 0 1.42-.653 1.42-1.46v-31.08c0-.807-.636-1.46-1.42-1.46m-234 24H1378v34h9.58c.784 0 1.42-.653 1.42-1.46v-31.08c0-.807-.636-1.46-1.42-1.46m187.42-4h37v-6h-37zm-234 24h37v-6h-37z",
    fill: "#818DB4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#818DB4",
    d: "M1590 434h6v-34h-6zm-234 24h6v-34h-6zm224-26h8v-2.066h-8V432zm0-2.967h8v-2.066h-8v2.066zm0-2.967h8V424h-8v2.066zM1346 456h8v-2.066h-8V456zm0-2.967h8v-2.066h-8v2.066zm0-2.967h8V448h-8v2.066z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1792 386)",
    fill: "#D2DAF0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 56h3v27h-3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 42,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1670.373 160.697c2.482-4.744 6.976-11.14 15.43-15.585 11.599-6.08 22.599-4.252 36.188-6.308 24.098-3.637 29.747-21.648 42.46-19.293 5.67 1.054 5.093 5.64 10.122 6.308 10.508 1.405 15.066-16.517 31.117-19.645 14.53-2.828 33.727 7.415 42.972 17.66 6.891 7.643 6.656 13.511 14.681 16.815 8.068 3.32 14.446-2.408 24.611-.738 9.416 1.546 20.802 14.18 25.488 20.786h-243.07z",
    fill: "url(#m)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289 362.517c5.523 0 10-4.477 10-10 0-3.682-3.333-10.682-10-21-6.667 10.318-10 17.318-10 21 0 5.523 4.477 10 10 10z",
    fill: "#AAB2CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilitiesHero);
export default __webpack_public_path__ + "static/media/utilities-hero.4f44343c2231a570e204352d8a476921.svg";
export { ForwardRef as ReactComponent };